import { AssetServiceLogCreateRequestEventType } from 'generatedTypes/asset/models';

export const EVENT_TYPE_ORDER = [
    AssetServiceLogCreateRequestEventType.REPLACED,
    AssetServiceLogCreateRequestEventType.SERVICED,
    AssetServiceLogCreateRequestEventType.INSPECTED,
    AssetServiceLogCreateRequestEventType.CALIBRATED
];

export const NO_SELECTION_INDEX = -1;

export const TEST_ID = 'eventTypeField';
